import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './navigation/Routes';
import { AuthProvider } from './context/authContext';
import React from 'react';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    const title = process.env.REACT_APP_PRODUCT_NAME || 'Begin Bright';
    document.title = title;

    // Dynamically change meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", process.env.REACT_APP_PRODUCT_DESCRIPTION || "Begin Bright");
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = "description";
      newMetaDescription.content = process.env.REACT_APP_PRODUCT_DESCRIPTION || "Begin Bright";
      document.head.appendChild(newMetaDescription);
    }

  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
